import { checkAvailabilityDirect } from '../redux/slices/apiSlice';

const validateField = async ({ fieldType, value }, dispatch) => {
  try {
    const { data } = await checkAvailabilityDirect(dispatch, { type: fieldType, value });

    if (!data?.available) {
      let errorMessage =
        fieldType === 'username'
          ? 'This username is already taken.'
          : 'This email is already registered.';
      throw new Error(errorMessage);
    }
  } catch (error) {
    throw new Error(error.message || 'Validation failed.');
  }
};

export default validateField;
